import { useState } from "react";
import { format } from "date-fns";
import { Calendar as CalendarIcon } from "lucide-react";
import { Calendar } from "../ui/calendar";
import { Popover, PopoverContent, PopoverTrigger } from "../ui/popover";

export default function DateField({ value, onChange, placeholder = "Pick a date", testid }) {
  const [open, setOpen] = useState(false);
  const selected = value ? new Date(value + "T00:00:00") : undefined;
  const today = new Date();
  today.setHours(0, 0, 0, 0);

  return (
    <Popover open={open} onOpenChange={setOpen}>
      <PopoverTrigger asChild>
        <button
          type="button"
          data-testid={testid}
          className="w-full h-11 flex items-center gap-2 px-3 rounded-xl border border-input bg-card text-left text-foreground hover:border-primary/50 transition-colors"
        >
          <CalendarIcon size={16} className="text-muted-foreground shrink-0" />
          {selected ? (
            <span>{format(selected, "EEE, d MMM yyyy")}</span>
          ) : (
            <span className="text-muted-foreground">{placeholder}</span>
          )}
        </button>
      </PopoverTrigger>
      <PopoverContent className="w-auto p-0" align="start">
        <Calendar
          mode="single"
          selected={selected}
          defaultMonth={selected}
          onSelect={(d) => {
            if (d) onChange(format(d, "yyyy-MM-dd"));
            setOpen(false);
          }}
          disabled={{ before: today }}
          initialFocus
        />
      </PopoverContent>
    </Popover>
  );
}
